/*=========================================================================================
  File Name: moduleCompanyState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	countries: [],
	countries_sitidata: [],
	cities: [],
	departments: [],
	dataSelectVisitPoint: [],
	config_list: [],
	role: [],
	status: [],
	category: [],
	typology: [],
};
